import React, {FC} from 'react';

import {Price} from 'components/price/price';

import {CartItemGlassesTypeV2Type} from '../../types';
import {QuoteItemV2OptionType} from '../../types/quoteItem';
import {BaseCartItem} from '../baseCartItem/baseCartItem';

import s from './cartItemUpgrade.scss';

export type PropsType = {
    item: CartItemGlassesTypeV2Type;
};

/**
 * Provides simplify display added options ONLY from PRODUCT UPGRADE PAGE
 * @constructor
 */
export const CartItemUpgrade: FC<PropsType> = ({item}) => (
    <BaseCartItem item={item}>
        {Object.values<QuoteItemV2OptionType>(item.options).map(addedOption => (
            <div className={s.row} key={addedOption.title}>
                <div className={s.option}>
                    <span className={s.name}>
                        {addedOption.option ? addedOption.option.title : 'No option provided'}
                    </span>
                </div>
                <div className={s.option}>
                    <span className={s.optionDescription}>{addedOption.title}</span>
                    {addedOption.finalPrice > 0 && (
                        <span className={s.price}>
                            <Price>{addedOption.finalPrice}</Price>
                        </span>
                    )}
                </div>
            </div>
        ))}
    </BaseCartItem>
);
